import { render, staticRenderFns } from "./pay-money-dialog.vue?vue&type=template&id=48948278&scoped=true&"
import script from "./pay-money-dialog.vue?vue&type=script&lang=js&"
export * from "./pay-money-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48948278",
  null
  
)

export default component.exports